import React, { Component } from "react";
import { Segment, Sidebar } from "semantic-ui-react";
import ReactDOM from "react-dom";
import {
  Map,
  Marker,
  InfoWindow,
  GoogleApiWrapper,
  Polyline,
} from "google-maps-react";
import createHistory from "history/createBrowserHistory";
import { withRouter } from "react-router-dom";
import "./styles/style.scss";

if (!window.AppHistory) {
  window.AppHistory = createHistory();
}

class InfoWindowEx extends Component {
  constructor(props) {
    super(props);
    this.infoWindowRef = React.createRef();
    this.contentElement = document.createElement("div");
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.children !== prevProps.children) {
      ReactDOM.render(
        React.Children.only(this.props.children),
        this.contentElement
      );
      this.infoWindowRef.current.infowindow.setContent(this.contentElement);
    }
  };

  render() {
    return <InfoWindow ref={this.infoWindowRef} {...this.props} />;
  }
}

export class MapContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Size: props.heidIcon ? props.heidIcon : 45,
      activeMarker: {},
      dataRecieve: props.dataDrawer,
      tags: "",
      dataOptions: props.dataOptions ? props.dataOptions : {},
      markerInfo: {},
      polylineDefault: "",
      polyline: props.polyline ? props.polyline : [],
      marker: props.marker,
      type: props.type,
      showingInfoWindow: false,
      showDrawerInfo: false,
    };
    this.buttonRef = React.createRef();
  }

  componentDidMount = () => {
    this.setState(
      {
        marker: this.props.marker,
      },
      () => {
        this.buildTags();
      }
    );
  };

  componentWillReceiveProps = (nextProps) => {
    this.setState(
      {
        marker: nextProps.marker,
      },
      () => {
        this.setState({ polyline: nextProps.polyline }, () => this.buildTags());
      }
    );
    this.setState(
      {
        dataRecieve: nextProps.dataDrawer,
        dataOptions: nextProps.dataOptions,
      },
      () => {
        let sendData = {
          data: nextProps.dataDrawer,
        };
        this.onMarkerClick(sendData, null, null);
      }
    );
  };

  onMarkerClick = (props, marker, e) => {
    switch (this.state.type) {
      case "info":
        this.setState({ showingInfoWindow: false }, () => {
          this.setState({
            showingInfoWindow: true,
            activeMarker: props.data,
            markerInfo: marker,
          });
        });
        break;
      case "drawer":
        this.setState({ showDrawerInfo: false }, () => {
          this.setState({ showDrawerInfo: true, activeMarker: props.data });
        });
        break;
      case "polyline":
        if (props.data) {
          if (props.data.OrigenLatitude && props.data.DestinoLatitude) {
            let polyline = [
              {
                lat: parseFloat(props.data.OrigenLatitude),
                lng: parseFloat(props.data.OrigenLongitude),
              },
              {
                lat: parseFloat(props.data.DestinoLatitude),
                lng: parseFloat(props.data.DestinoLongitude),
              },
            ];
            this.setState({ polyline: polyline });
          }
        }
        break;
      case "polylineDrawer":
        if (props.data) {
          if (props.data.OrigenLatitude && props.data.DestinoLatitude) {
            let polyline = [
              {
                lat: parseFloat(props.data.OrigenLatitude),
                lng: parseFloat(props.data.OrigenLongitude),
              },
              {
                lat: parseFloat(props.data.DestinoLatitude),
                lng: parseFloat(props.data.DestinoLongitude),
              },
            ];
            this.setState({ polyline: polyline });
          }
          this.setState({ showDrawerInfo: false }, () => {
            this.setState({ showDrawerInfo: true, activeMarker: props.data });
          });
        }
        break;
      default:
    }
  };

  onInfoWindowClose = () => {
    this.setState({
      showingInfoWindow: false,
    });
  };

  buildTags = () => {
    let { marker, type } = this.state;
    let tags = [];
    let polylineDefault = [];
    marker.map((e) => {
      tags.push(
        <Marker
          key={e.key}
          onClick={this.onMarkerClick}
          title={e.title}
          name={e.name}
          info={e}
          data={e.data}
          position={e.position}
          icon={{
            url: e.icon.url,
            scaledSize: new window.google.maps.Size(
              this.state.Size,
              this.state.Size
            ),
          }}
        />
      );
      return e;
    });
    var lineSymbol = {
      path: "M 0,-1 0,1",
      strokeOpacity: 1,
      scale: 3,
    };
    if (type === "polyline") {
      polylineDefault.push(
        <Polyline
          key={Math.random()}
          path={this.props.data ? this.props.data : []}
          icons={[
            {
              icon: lineSymbol,
              offset: "0",
              repeat: "20px",
            },
          ]}
          strokeOpacity={0}
        />
      );
    }
    if (type === "polylineDrawer") {
      polylineDefault.push(
        <Polyline
          key={Math.random()}
          path={this.props.data ? this.props.data : []}
          icons={[
            {
              icon: lineSymbol,
              offset: "0",
              repeat: "20px",
            },
          ]}
          strokeOpacity={0}
        />
      );
    }
    this.setState({ tags, polylineDefault });
  };

  redirectTo = (event) => {
    this.props.history.push(this.state.dataOptions.config.link);
  };

  render() {
    let {
      activeMarker,
      markerInfo,
      showingInfoWindow,
      polyline,
      polylineDefault,
    } = this.state;
    if (!this.props.google) {
      return <div>Loading...</div>;
    }
    const info = [
      {
        data: "",
        img: true,
        title: "Aduana",
        value: activeMarker.Aduana,
      },
      {
        data: (
          <em
            className="fa-2x mr-2 fas fa-arrow-alt-circle-right"
            style={{ color: "#001489" }}
          ></em>
        ),
        img: false,
        title: "Total Importaciones",
        value: activeMarker.TotalImpo,
      },
      {
        data: (
          <em
            className="fa-2x mr-2 fas fa-arrow-alt-circle-right"
            style={{ color: "#A7A8A9" }}
          ></em>
        ),
        img: false,
        title: "Total DTA´s",
        value: activeMarker.TotalDTA,
      },
      {
        data: (
          <em
            className="fa-2x mr-2 fas fa-arrow-alt-circle-left"
            style={{ color: "#582C83" }}
          ></em>
        ),
        img: false,
        title: "Total Exportaciones",
        value: activeMarker.TotalExpo,
      },
    ];

    var dataOptions = this.state.dataOptions ? this.state.dataOptions.data : "";

    if (dataOptions && markerInfo) {
      dataOptions.map((e) => {
        if (markerInfo.info) {
          e.value = markerInfo.info[e.key];
        }
        return e;
      });
    }
    let dataInfo = this.state.dataOptions
      ? this.state.dataOptions?.data
        ? this.state.dataOptions?.data
        : info
      : info;

    return (
      <>
        <Sidebar.Pushable as={Segment}>
          <Sidebar.Pusher>
            <Segment>
              <div
                style={{
                  position: "relative",
                  height: this.props.maxHeight ? this.props.maxHeight : "500px",
                }}
              >
                <Map
                  styles={[
                    {
                      elementType: "geometry",
                      stylers: [{ color: "#ffffff" }],
                    },
                    {
                      elementType: "labels.text.stroke",
                      stylers: [{ color: "red" }],
                    },
                    {
                      elementType: "labels.text.fill",
                      stylers: [{ color: "red" }],
                    },
                    {
                      featureType: "landscape",
                      elementType: "geometry",
                      stylers: [
                        { color: "#e1e3eb" }, // Red color
                      ],
                    },
                    {
                      featureType: "water",
                      elementType: "geometry",
                      stylers: [{ color: "white" }],
                    },
                    {
                      featureType: "water",
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#515c6d" }],
                    },
                    {
                      featureType: "water",
                      elementType: "labels.text.stroke",
                      stylers: [{ color: "#42AFEE" }],
                    },
                  ]}
                  disableDefaultUI={true}
                  google={this.props.google}
                  zoom={this.props.zoom ? this.props.zoom : 2}
                  initialCenter={
                    this.props.position
                      ? this.props.position
                      : {
                          lat: 24.3005846,
                          lng: -30.447409,
                        }
                  }
                >
                  {this.state.tags}
                  <InfoWindowEx
                    visible={showingInfoWindow}
                    onClose={this.onInfoWindowClose}
                    marker={markerInfo}
                  >
                    <div style={{ minWidth: 250 }}>
                      {dataInfo.map((f, index) => {
                        return (
                          <div
                            key={index}
                            className="row"
                            style={{ marginTop: index === 0 ? 0 : 10 }}
                          >
                            <div className="col-1">
                              {f.img ? (
                                <img
                                  alt="img"
                                  src="https://fsposeidon.blob.core.windows.net/roldan/ICONOGRAFIA_ROL4LL_TRANSPORT_RGB-19.png"
                                  width="25"
                                  height="25"
                                  className="mr-2"
                                ></img>
                              ) : (
                                f.data
                              )}
                            </div>
                            <div
                              className="col-6"
                              style={{
                                marginLeft: 5,
                                fontWeight: "bold",
                                marginTop:
                                  index === 0 || index === dataInfo.length - 1
                                    ? 2
                                    : 0,
                              }}
                            >
                              {f.title}
                            </div>
                            <div
                              className="col-4"
                              style={{ textAlign: "center" }}
                            >
                              {f.value}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </InfoWindowEx>
                  {polylineDefault}
                  <Polyline
                    path={polyline}
                    strokeColor="#0000FF"
                    strokeOpacity={0.8}
                    strokeWeight={2}
                  />
                </Map>
              </div>
            </Segment>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyAl_10ZKSqnrviAV-KSQ6c8i4Sa_gEhEmA",
  v: "3.30",
})(withRouter(MapContainer));
